import React, { useState, useEffect } from 'react';
import { newsletterAPI } from '../services/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Mail, CheckCircle, Bell } from 'lucide-react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await newsletterAPI.subscribe({ email, name: name || null });
      setStatus({ type: 'success', message: data.message });
      setEmail('');
      setName('');
    } catch (err) {
      setStatus({ type: 'error', message: 'Something went wrong. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="py-16 px-4" data-testid="newsletter-section">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-r from-teal-700 via-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-white shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Bell className="w-7 h-7 text-white" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-3">Stay Updated</h2>
            <p className="text-teal-100 max-w-xl mx-auto text-sm md:text-base">
              Subscribe to receive updates on new blog posts, upcoming camps, medical insights, and community initiatives
            </p>
          </div>

          {status?.type === 'success' ? (
            <div className="flex items-center justify-center gap-3 bg-white/10 rounded-xl p-6" data-testid="newsletter-success">
              <CheckCircle className="w-6 h-6 text-green-300" />
              <p className="text-white font-medium">{status.message}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="max-w-lg mx-auto space-y-3" data-testid="newsletter-form">
              <div className="flex flex-col sm:flex-row gap-3">
                <Input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Your name (optional)"
                  className="bg-white/10 border-white/20 text-white placeholder:text-teal-200 h-12"
                  data-testid="newsletter-name-input"
                />
                <Input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="bg-white/10 border-white/20 text-white placeholder:text-teal-200 h-12"
                  data-testid="newsletter-email-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto bg-white text-teal-700 hover:bg-teal-50 font-semibold h-12 px-8"
                data-testid="newsletter-submit-button"
              >
                <Mail className="w-4 h-4 mr-2" />
                {loading ? 'Subscribing...' : 'Subscribe'}
              </Button>
              {status?.type === 'error' && (
                <p className="text-red-300 text-sm" data-testid="newsletter-error">{status.message}</p>
              )}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
